import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { element } from 'protractor';
import { ModalAlert } from '../modal.alert/modal.alert.component';
import { isNumber } from 'util';

@Component({
  selector: 'app-dialog-cuota-inscripcion',
  templateUrl: './dialog-cuota-inscripcion.component.html',
  styleUrls: ['./dialog-cuota-inscripcion.component.css']
})
export class DialogCuotaInscripcionComponent implements OnInit {
  form: any = {
    nit: {
      value: null,
      messages: null,
      required: true,
    }
  }

  error = "";

  constructor(public dialogRef: MatDialogRef<ModalAlert>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data != null) {
      this.form.nit.value = data;
    }
  }

  ngOnInit(): void {
  }

  validarValor(event: KeyboardEvent, e: keyof any) {
    const number = /^[0-9]$/;
    let value = (event.target as HTMLInputElement).value;
    let text = '';
    ( this.form[e].value ?? '' ).toString().split('').forEach((element: string) => {
      if (number.test(element)) {
        text += element;
        let numero = '';
        let result = Object.assign([], value);
        result.forEach(element => {
          if (!isNaN(Number(element))) {
            numero += '' + element;
          }
        });
        if (numero !== '') {
          if (numero.length > 6) {
            numero = numero.substring(0, 6);
          }
          this.form.nit.value = new Intl.NumberFormat('es-MX').format(parseInt(numero, 10));
        }
      }
    });
    this.form[e].value = text;
  }

  continuar(value:any) {

    if (value == null) {
      this.error = "Valor incorrecto";
      return;
    }
    if (value == "") {
      this.error = "Valor incorrecto";
      return;
    }
    if (value < 0) {
      this.error = "Valor incorrecto";
      return;
    }
    if (value.length > 6) {
      this.error = "El número no puede ser mayor a $999.999";
      return;
    }

    this.dialogRef.close(value);
  }
}
